import { render } from "./BBadge.vue?vue&type=template&id=cee64a4a&scoped=true&ts=true"
import script from "./BBadge.vue?vue&type=script&lang=ts"
export * from "./BBadge.vue?vue&type=script&lang=ts"

import "./BBadge.vue?vue&type=style&index=0&id=cee64a4a&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/Momentum/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cee64a4a"]])

export default __exports__